<template>
  <b-overlay :show="busy">
    <b-button
      :disabled="!page.is_draft"
      :variant="page.is_draft ? 'primary' : 'secondary'"
      @click="setApproval(true)"
      size="sm"
      class="text-nowrap mr-2"
    >
      {{ buttonText }}
      <b-badge class="shortcut">Enter</b-badge>
    </b-button>
    <b-button
      v-if="page.is_draft && title.text != page.title"
      variant="link"
      @click="$emit('revert')"
      size="sm"
      class="ml-2"
    >
      Revert
    </b-button>
    <span v-if="page.approved_at" class="mb-2">
      <ResultBadge :page="page" v-model="resultStatus" />
      <b-link v-if="resultStatus === false && buttonText != 'Revert'" @click="revert()" v-b-tooltip.hover="'Revert back to your original title'" :disabled="busy" class="ml-1">Revert</b-link>
    </span>
    <div v-if="page.approved_at" class="text-muted text-small mt-2">
      <span v-if="isAutomated">Title change found on </span>
      <span v-else>
        {{ actionName.replace(/e$/, '') + 'ed' }} on 
      </span>
      <abbr class="text-muted" id="title-diff" :title="page.approved_at">{{page.approved_at|formatDate}}</abbr>
      <b-popover target="title-diff" triggers="hover focus" title="Title Changes">
        <Diff :old="page.experiment.old.title" :new="page.experiment.new.title" />
      </b-popover>
    </div>
  </b-overlay>
</template>
<script>
import Diff from '@/components/Diff.vue'
import ResultBadge from '@/components/ResultBadge'
import PAGE_MUTATE from '@/graphql/PageMutate.gql'
import {uniqBy, pick, get} from 'lodash'

export default {
  name: 'Approve',
  components: { Diff, ResultBadge },
  props: {
    site: Object,
    page: Object,
    title: Object,
  },
  data() {
    return {
      busy: false,
      resultStatus: null,
    }
  },
  watch: {
    page() {
      this.busy = false
    }
  },
  computed: {
    hasPublishing() {
      return get(this, 'settings.cloudflare.ENABLED') || get(this, 'settings.wordpress.ENABLED')
    },
    hasAnyApproved() {
      return !this.site.total_approved || this.site.total_approved.aggregate.count > 0
    },
    actionName() {
      return this.hasPublishing ? 'Publish' : 'Save'
    },
    buttonText() {
      return this.page.approved_at && this.title.text == this.page.title ? 'Revert' : this.actionName
    },
    isAutomated() {
      return !!get(this.page, 'experiment.id') && !get(this.page, 'experiment.created_by')
    }
  },
  methods: {
    async setApproval(isApproved) {
      _zyppy.track('Page Approved', {isApproved, ...pick(this.page, ['id', 'custom_title', 'title'])})
      const changes = {
        optimized_title: isApproved ? this.page.custom_title : null,
        approved_at: isApproved && this.page.custom_title ? new Date() : null,
        published_at: null,
      }
      await this.$apollo.mutate({
        mutation: PAGE_MUTATE,
        variables: {
          id: this.page.id,
          changes
        }
      })
      this.$emit('refresh')
    },
    async revert() {
      this.busy = true
      _zyppy.track('Page Reverted', {page_id: this.page.id})
      const changes = {
        optimized_title: null,
        approved_at: null,
        published_at: null,
        custom_title: null,
      }
      await this.$apollo.mutate({
        mutation: PAGE_MUTATE,
        variables: {
          id: this.page.id,
          changes
        }
      })
      this.busy = false
      this.$emit('refresh')
    },
  }
}
</script>
